var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStrava = function SvgStrava(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 50,
    viewBox: "10 0 80 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41.03 47.852-5.572-10.976h-8.172L41.03 64l13.736-27.124h-8.18M27.898 21.944l7.564 14.928h11.124L27.898 0 9.234 36.876H20.35"
  })));
};
export default SvgStrava;